import {
  GET_SHELL_USER_REQUEST,
  GET_SHELL_USER_REQUEST_SUCCESS,
  GET_SHELL_USER_REQUEST_FAILURE,
  SHELL_USER_ALREADY_SET,
  REGISTER_SHELL_USER_REQUEST,
  REGISTER_SHELL_USER_REQUEST_SUCCESS,
  REGISTER_SHELL_USER_REQUEST_FAILURE,
} from '../constants/actionTypes'

const initialState = {
  isFetching: false,
  isChanging: false,
  shellUser: {},
  roles: [],
  company: '',
  errorMessage: null,
  is_shell_company: false,
}

const shellUser = function(state = initialState, action) {
  switch (action.type) {
    case GET_SHELL_USER_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case GET_SHELL_USER_REQUEST_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.message,
      }
    case SHELL_USER_ALREADY_SET:
      return {
        ...state,
        isFetching: false,
      }
    case GET_SHELL_USER_REQUEST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        shellUser: action.shellUser,
        roles: action.roles,
        company: action.company,
        invitee: action.invitee,
        invitation_type: action.invitation_type,
        is_shell_company: action.is_shell_company,
      }
    case REGISTER_SHELL_USER_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case REGISTER_SHELL_USER_REQUEST_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.message,
      }
    case REGISTER_SHELL_USER_REQUEST_SUCCESS:
      return {
        ...state,
        isFetching: false,
      }
    default:
      return state
  }
}

export default shellUser
